import React from "react"
import { motion, AnimatePresence } from "framer-motion"

// Hooks, State & Querys
import { useScrollFreeze } from "../../hooks"
import { useAppState } from "../../state/appState"
import { useSiteConfig } from "../../GraphQl/useSiteConfig"

// Components
import { PageLink, PathLink, SocialLink } from "../ui"

// Animation Variants
const navWrapperVars = {
  closed: {
    opacity: 0,
    transition: {
      duration: 0.5,
      delay: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
  open: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
}
const navAniVars = {
  closed: {
    y: 20,
    opacity: 0,
  },
  open: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      delay: 0.5,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
}

const socialAniVars = {
  closed: {
    y: 20,
    opacity: 0,
  },
  open: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      delay: 0.8,
      ease: [0.43, 0.13, 0.23, 0.96],
    },
  },
}

const DrawNavInner = () => {
  useScrollFreeze()
  const { mainNav, socialLinks } = useSiteConfig()
  const { closeNav } = useAppState()

  return (
    <motion.div
      className="fixed h-screen w-full bg-marphonaBrown text-sand flex items-center justify-center flex-col z-40 top-0 left-0"
      variants={navWrapperVars}
      initial="closed"
      animate="open"
      exit="closed"
    >
      <motion.nav className="grid gap-y-6 text-center" variants={navAniVars}>
        {mainNav.map(item =>
          item._type === "pageLink" ? (
            <PageLink
              {...item}
              className="font-display text-xl md:text-4xl hover:text-marphonaGold transition-colors"
              activeClassName="text-marphonaGold"
              onClick={closeNav}
            />
          ) : (
            <PathLink
              {...item}
              className="font-display text-xl md:text-4xl hover:text-marphonaGold transition-colors"
              activeClassName="text-marphonaGold"
              onClick={closeNav}
            />
          )
        )}
      </motion.nav>
      <motion.nav
        className="grid grid-flow-col gap-x-4 mt-10"
        variants={socialAniVars}
      >
        {socialLinks.map(item => (
          <SocialLink
            {...item}
            className="w-8 hover:text-marphonaGold transition-colors"
            target="_blank"
          />
        ))}
      </motion.nav>
    </motion.div>
  )
}

export const DrawNav = () => {
  const { navOpen } = useAppState()
  return <AnimatePresence>{navOpen && <DrawNavInner />}</AnimatePresence>
}
